(function() {
  /* Second Custom Liquid block may be outside #rn-our-story-root; scope with .rn-our-story */
  var revealEls = document.querySelectorAll(".rn-our-story .reveal:not(.visible)");
  var revealObs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) e.target.classList.add("visible");
    });
  }, { threshold: 0.10 });
  revealEls.forEach(function(el) { revealObs.observe(el); });
})();
